module.exports = __webpack_public_path__ + "img/twitter-32px.a21b3730.svg";